
import rolesListRedux from '../../views/list/redux/slice'
import roleEditRedux from '../../modals/edit/redux/slice'

//export redux objects
export default {
    rolesListRedux,
    roleEditRedux
};